export const getSelectedDeparturePostalOperators = state =>
  state.postalOperatorUnlocodeSelector.departure.nodes
    .map(node => ({
      ...node,
      children: node.children.filter(child =>
        state.postalOperatorUnlocodeSelector.departure.checkedUnlocodes
          .includes(child.value)),
    }))
    .filter(node => node.children && node.children.length);

export const getDeparturePostalOperators =
  state => state.postalOperatorUnlocodeSelector.departure.nodes;
export const getDepartureCheckedUnlocodes =
  state => state.postalOperatorUnlocodeSelector.departure.checkedUnlocodes;
export const getExpandedDeparturePostalOperators =
  state => state.postalOperatorUnlocodeSelector.departure.expandedPostalOperators;
export const getExpandedDeparturePostalOperatorsUnlocodeAdmin =
  state => state.postalOperatorUnlocodeSelector.departure.expandedPostalOperatorsUnlocodeAdmin;
export const getDepartureUnlocodeSelections =
  state => state.postalOperatorUnlocodeSelector.departure.selections;

export const getSelectedArrivalPostalOperators = state =>
  state.postalOperatorUnlocodeSelector.arrival.nodes
    .map(node => ({
      ...node,
      children: node.children.filter(child =>
        state.postalOperatorUnlocodeSelector.arrival.checkedUnlocodes
          .includes(child.value)),
    }))
    .filter(node => node.children && node.children.length);

export const getArrivalPostalOperators = state => state.postalOperatorUnlocodeSelector.arrival.nodes;
export const getArrivalCheckedUnlocodes =
    state => state.postalOperatorUnlocodeSelector.arrival.checkedUnlocodes;
export const getExpandedArrivalPostalOperators =
    state => state.postalOperatorUnlocodeSelector.arrival.expandedPostalOperators;
export const getArrivalUnlocodeSelections =
    state => state.postalOperatorUnlocodeSelector.arrival.selections;

export const getDirections = state =>
  state.postalOperatorUnlocodeSelector.directions;
export const getIsDirectionsSwitched = state =>
  state.postalOperatorUnlocodeSelector.directions.switched;
